import { render, staticRenderFns } from "./product-box.vue?vue&type=template&id=638adef0&"
import script from "./product-box.vue?vue&type=script&lang=js&"
export * from "./product-box.vue?vue&type=script&lang=js&"
import style0 from "./product-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports